/* =========================================================
   DEKOFAR PRODUCT SYSTEM V3
   GALLERY JAVASCRIPT

   - Main gallery
   - Boundary-aware navigation (no loop)
   - Thumbnail scrolling
   - Main swipe
   - Pinch zoom + pan
   - Fullscreen lightbox
   - Lightbox swipe
   - Lightbox pinch zoom + pan
   - Empty-area close
   - Keyboard navigation

   TEASER:
   - Otomatik oynatma yoktur
   - Video yalnızca kullanıcı butona basınca lightbox'ta açılır
   - Metafield boşsa Liquid video butonunu üretmez

   COMMERCE UI:
   - Mobil ana galeri sayacı
   - Mobil lightbox sayacı
   - Varyanta göre ücretsiz / bugün kargoda rozetleri
   - Tüm Özellikler kaydırma butonu

   LIGHTBOX:
   - Fullscreen
   - Thumbnail navigation
   - Video playback
   - Teaser playback
   - Empty area close
   - Keyboard
   - Swipe
   - Zoom

   Requires:
   - dekofar-v2-core.js
   ========================================================= */


function dekofarV2InitProductGalleries(scope) {
  const root = scope || document;

  dekofarV2InitScrollProductVideos(
    root
  );

  root
    .querySelectorAll('[data-dekofar-v2-gallery]')
    .forEach((gallery) => {

      if (
        gallery.dataset.dekofarV2GalleryInitialized ===
        'true'
      ) {
        return;
      }

      const items = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-gallery-item]'
        )
      ];

      if (!items.length) {
        return;
      }

      gallery.dataset.dekofarV2GalleryInitialized =
        'true';


      /* =====================================================
         MAIN GALLERY
         ===================================================== */

      const thumbnails = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-gallery-thumbnail]'
        )
      ];

      const previousButton =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-prev]'
        );

      const nextButton =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-next]'
        );

      const mainSwipeArea =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-swipe]'
        ) ||
        gallery.querySelector(
          '.dekofar-v2-gallery__stage'
        );

      const thumbStrip =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-thumbnails]'
        );

      const thumbPrev =
        gallery.querySelector(
          '[data-dekofar-v2-thumb-prev]'
        );

      const thumbNext =
        gallery.querySelector(
          '[data-dekofar-v2-thumb-next]'
        );

      const firstMediaId =
        gallery.getAttribute(
          'data-first-media-id'
        );

      const mobileCurrentIndex =
        gallery.querySelector(
          '[data-dekofar-v2-current-index]'
        );

      const mobileDots = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-gallery-dot]'
        )
      ];

      const lightboxCurrentIndex =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-current-index]'
        );

      const videoButton =
        gallery.querySelector(
          '[data-dekofar-v2-video-button]'
        );

      const featuresButton =
        gallery.querySelector(
          '[data-dekofar-v2-scroll-to-features]'
        );

      const freeShippingBadge =
        gallery.querySelector(
          '[data-dekofar-v2-free-shipping-badge]'
        );

      const shippingBadges =
        gallery.querySelector(
          '[data-dekofar-v2-shipping-badges]'
        );

      const sameDayShippingBadge =
        gallery.querySelector(
          '[data-dekofar-v2-same-day-badge]'
        );

      const productRoot =
        gallery.closest(
          '.dekofar-v2-product'
        );

      const reels =
        gallery.querySelector(
          '[data-dekofar-v2-reels]'
        );

      const reelsVideo =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-video]'
            )
          : null;

      const reelsCloseButtons =
        reels
          ? [
              ...reels.querySelectorAll(
                '[data-dekofar-v2-reels-close]'
              )
            ]
          : [];

      const reelsLikeButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-like]'
            )
          : null;

      const reelsDislikeButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-dislike]'
            )
          : null;

      const reelsShareButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-share]'
            )
          : null;

      const reelsViewCount =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-view-count]'
            )
          : null;

      const reelsSpeedButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-speed]'
            )
          : null;

      const reelsAddToCartButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-add-to-cart]'
            )
          : null;

      const reelsInspectProductButton =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-inspect-product]'
            )
          : null;

      const reelsMessage =
        reels
          ? reels.querySelector(
              '[data-dekofar-v2-reels-message]'
            )
          : null;

      let lastReelsTrigger = null;
      let reelsViewTimer = null;

      let galleryVariantData = null;

      const galleryVariantDataElement =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-variant-data]'
        );

      if (galleryVariantDataElement) {
        try {
          galleryVariantData = JSON.parse(
            galleryVariantDataElement.textContent
          );
        } catch (error) {
          galleryVariantData = null;
        }
      }

      let currentIndex = 0;


      /* =====================================================
         SETTINGS
         ===================================================== */

      /*
       * Sayfa açıldıktan kaç ms sonra
       * teaser video devreye girsin?
       *
       * 2000 = 2 saniye
       */
      const TEASER_DELAY_MS = 2000;

      /*
       * Teaser item ekrana geldikten sonra
       * poster ne kadar beklesin?
       */
      const TEASER_POSTER_DELAY_MS = 180;


      /* =====================================================
         TEASER
         ===================================================== */

      const hasTeaserVideo =
        gallery.getAttribute(
          'data-has-teaser-video'
        ) === 'true';

      const teaserItem =
        gallery.querySelector(
          '[data-dekofar-v2-teaser-item]'
        );

      const teaserVideo =
        teaserItem
          ? teaserItem.querySelector('video')
          : null;

      const teaserPoster =
        teaserItem
          ? teaserItem.querySelector(
              '[data-dekofar-v2-teaser-poster]'
            )
          : null;

      let teaserTimeout = null;
      let teaserPosterTimeout = null;

      let teaserStarted = false;
      let teaserCancelled = false;
      let teaserFinished = false;


      /* =====================================================
         PREPARE TEASER VIDEO
         ===================================================== */

      if (teaserVideo) {
        try {
          teaserVideo.muted = true;
          teaserVideo.defaultMuted = true;
          teaserVideo.playsInline = true;

          teaserVideo.setAttribute(
            'muted',
            ''
          );

          teaserVideo.setAttribute(
            'playsinline',
            ''
          );

          teaserVideo.setAttribute(
            'webkit-playsinline',
            ''
          );

          /*
           * Shopify/browser video yüklemesini
           * daha erken başlatabilsin.
           */
          if (
            !teaserVideo.getAttribute(
              'preload'
            )
          ) {
            teaserVideo.setAttribute(
              'preload',
              'auto'
            );
          }
        } catch (error) {}
      }


      /* =====================================================
         LIGHTBOX
         ===================================================== */

      const lightbox =
        gallery.querySelector(
          '[data-dekofar-v2-gallery-lightbox]'
        );

      const lightboxOpenButtons = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-lightbox-open]'
        )
      ];

      const lightboxCloseButtons = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-lightbox-close]'
        )
      ];

      const lightboxItems = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-lightbox-item]'
        )
      ];

      const lightboxThumbnails = [
        ...gallery.querySelectorAll(
          '[data-dekofar-v2-lightbox-thumbnail]'
        )
      ];

      const lightboxPreviousButton =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-prev]'
        );

      const lightboxNextButton =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-next]'
        );

      const lightboxSwipeArea =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-swipe]'
        ) ||
        gallery.querySelector(
          '.dekofar-v2-gallery-lightbox__media'
        );

      const lightboxThumbStrip =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-thumbnails]'
        );

      const lightboxThumbPrev =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-thumb-prev]'
        );

      const lightboxThumbNext =
        gallery.querySelector(
          '[data-dekofar-v2-lightbox-thumb-next]'
        );

      let lightboxIndex = 0;
      let lastLightboxTrigger = null;

      let navEmphasisTimer = null;
      let mainNavEmphasisTimer = null;


      /* =====================================================
         ZOOM CONTROLLERS
         ===================================================== */

      const mainZoomControllers = [];
      const lightboxZoomControllers = [];


      /* =====================================================
         VIDEO HELPERS
         ===================================================== */

      const pauseVideo = (
        video,
        reset = false
      ) => {

        if (!video) {
          return;
        }

        try {
          video.pause();

          if (reset) {
            video.currentTime = 0;
          }
        } catch (error) {}
      };


      const playVideo = (
        video,
        reset = false
      ) => {

        if (!video) {
          return false;
        }

        try {
          /*
           * Otomatik oynatmanın çalışması için
           * muted olması önemli.
           */
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          video.setAttribute(
            'muted',
            ''
          );

          video.setAttribute(
            'playsinline',
            ''
          );

          video.setAttribute(
            'webkit-playsinline',
            ''
          );

          if (reset) {
            try {
              video.currentTime = 0;
            } catch (error) {}
          }

          const promise =
            video.play();

          if (
            promise &&
            typeof promise.catch ===
              'function'
          ) {
            promise.catch(() => {
              /*
               * Browser autoplay bloklarsa
               * uygulamayı kırma.
               */
            });
          }

          return true;

        } catch (error) {
          return false;
        }
      };


      const stopAllGalleryVideos = (
        exceptItem = null
      ) => {

        items.forEach((item) => {

          if (item === exceptItem) {
            return;
          }

          item
            .querySelectorAll('video')
            .forEach((video) => {
              pauseVideo(
                video,
                true
              );
            });
        });

        if (
          teaserItem &&
          teaserItem !== exceptItem
        ) {
          pauseVideo(
            teaserVideo,
            true
          );
        }
      };


      const stopLightboxVideos = (
        exceptItem = null
      ) => {

        lightboxItems.forEach(
          (item) => {

            if (item === exceptItem) {
              return;
            }

            item
              .querySelectorAll('video')
              .forEach((video) => {
                pauseVideo(
                  video,
                  true
                );
              });
          }
        );
      };


      /* =====================================================
         TEASER HELPERS
         ===================================================== */

      const clearTeaserTimers = () => {

        if (teaserTimeout) {
          clearTimeout(
            teaserTimeout
          );
        }

        if (teaserPosterTimeout) {
          clearTimeout(
            teaserPosterTimeout
          );
        }

        teaserTimeout = null;
        teaserPosterTimeout = null;
      };


      /*
       * Kullanıcı kendi isteğiyle
       * galeri/varyant değiştirirse teaser
       * tamamen iptal edilir.
       */
      const cancelTeaser = () => {

        teaserCancelled = true;

        clearTeaserTimers();

        pauseVideo(
          teaserVideo,
          true
        );

        if (teaserPoster) {
          teaserPoster.hidden = false;
        }
      };


      /* =====================================================
         NAVIGATION VISIBILITY
         ===================================================== */

      const updateMainNav = () => {

        if (previousButton) {
          previousButton.hidden =
            currentIndex <= 0;
        }

        if (nextButton) {
          nextButton.hidden =
            currentIndex >=
            items.length - 1;
        }
      };


      const updateLightboxNav = () => {

        if (lightboxPreviousButton) {
          lightboxPreviousButton.hidden =
            lightboxIndex <= 0;
        }

        if (lightboxNextButton) {
          lightboxNextButton.hidden =
            lightboxIndex >=
            lightboxItems.length - 1;
        }
      };


      const emphasizeMainNav = () => {

        [
          previousButton,
          nextButton
        ].forEach((button) => {

          if (
            button &&
            !button.hidden
          ) {
            button.classList.add(
              'is-emphasized'
            );
          }
        });

        if (mainNavEmphasisTimer) {
          clearTimeout(
            mainNavEmphasisTimer
          );
        }

        mainNavEmphasisTimer =
          setTimeout(() => {

            [
              previousButton,
              nextButton
            ].forEach((button) => {

              if (button) {
                button.classList.remove(
                  'is-emphasized'
                );
              }
            });

          }, 1100);
      };


      const emphasizeLightboxNav = () => {

        [
          lightboxPreviousButton,
          lightboxNextButton
        ].forEach((button) => {

          if (
            button &&
            !button.hidden
          ) {
            button.classList.add(
              'is-emphasized'
            );
          }
        });

        if (navEmphasisTimer) {
          clearTimeout(
            navEmphasisTimer
          );
        }

        navEmphasisTimer =
          setTimeout(() => {

            [
              lightboxPreviousButton,
              lightboxNextButton
            ].forEach((button) => {

              if (button) {
                button.classList.remove(
                  'is-emphasized'
                );
              }
            });

          }, 1100);
      };


      /* =====================================================
         THUMBNAIL STRIP NAVIGATION
         ===================================================== */

      const updateStripNav = (
        strip,
        prevButton,
        nextButton
      ) => {

        if (!strip) {
          return;
        }

        const maxScroll =
          Math.max(
            0,
            strip.scrollWidth -
            strip.clientWidth
          );

        const hasOverflow =
          maxScroll > 4;

        if (prevButton) {
          prevButton.hidden =
            !hasOverflow ||
            strip.scrollLeft <= 4;
        }

        if (nextButton) {
          nextButton.hidden =
            !hasOverflow ||
            strip.scrollLeft >=
              maxScroll - 4;
        }
      };


      const bindStripNav = (
        strip,
        prevButton,
        nextButton
      ) => {

        if (!strip) {
          return;
        }

        const step = () =>
          Math.max(
            140,
            Math.round(
              strip.clientWidth *
              0.72
            )
          );


        if (prevButton) {
          prevButton.addEventListener(
            'click',
            () => {

              strip.scrollBy({
                left: -step(),
                behavior: 'smooth'
              });
            }
          );
        }


        if (nextButton) {
          nextButton.addEventListener(
            'click',
            () => {

              strip.scrollBy({
                left: step(),
                behavior: 'smooth'
              });
            }
          );
        }


        strip.addEventListener(
          'scroll',
          () => {

            updateStripNav(
              strip,
              prevButton,
              nextButton
            );
          },
          {
            passive: true
          }
        );


        window.addEventListener(
          'resize',
          () => {

            updateStripNav(
              strip,
              prevButton,
              nextButton
            );
          },
          {
            passive: true
          }
        );


        requestAnimationFrame(() => {

          updateStripNav(
            strip,
            prevButton,
            nextButton
          );
        });
      };


      bindStripNav(
        thumbStrip,
        thumbPrev,
        thumbNext
      );

      bindStripNav(
        lightboxThumbStrip,
        lightboxThumbPrev,
        lightboxThumbNext
      );


      /* =====================================================
         MAIN THUMBNAIL STATE
         ===================================================== */

      const setMainThumbnailState = (
        mediaId,
        shouldScroll = true
      ) => {

        thumbnails.forEach(
          (thumbnail) => {

            const isActive =
              thumbnail.getAttribute(
                'data-media-id'
              ) ===
              String(mediaId);

            thumbnail.classList.toggle(
              'is-active',
              isActive
            );

            thumbnail.setAttribute(
              'aria-current',
              isActive
                ? 'true'
                : 'false'
            );


            if (
              isActive &&
              shouldScroll
            ) {
              try {
                thumbnail.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'center'
                });
              } catch (error) {}
            }
          }
        );


        requestAnimationFrame(() => {

          updateStripNav(
            thumbStrip,
            thumbPrev,
            thumbNext
          );
        });
      };


      /* =====================================================
         RESET ZOOM
         ===================================================== */

      function resetAllMainZoom() {

        mainZoomControllers.forEach(
          (controller) => {

            controller.reset(
              false
            );
          }
        );
      }


      function resetAllLightboxZoom() {

        lightboxZoomControllers.forEach(
          (controller) => {

            controller.reset(
              false
            );
          }
        );
      }


      function isAnyMainZoomed() {

        return mainZoomControllers.some(
          (controller) =>
            controller.isZoomed()
        );
      }


      function isAnyLightboxZoomed() {

        return lightboxZoomControllers.some(
          (controller) =>
            controller.isZoomed()
        );
      }


      /* =====================================================
         SHOW MAIN MEDIA
         ===================================================== */

      const showMediaByIndex = (
        index,
        options = {}
      ) => {

        if (!items.length) {
          return false;
        }


        /*
         * LOOP YOK.
         */
        if (
          index < 0 ||
          index >= items.length
        ) {
          return false;
        }


        resetAllMainZoom();

        currentIndex = index;

        if (mobileCurrentIndex) {
          mobileCurrentIndex.textContent =
            String(index + 1);
        }

        mobileDots.forEach(
          (dot, dotIndex) => {
            const isActive =
              dotIndex === index;

            dot.classList.toggle(
              'is-active',
              isActive
            );

            dot.setAttribute(
              'aria-current',
              isActive
                ? 'true'
                : 'false'
            );
          }
        );

        const activeItem =
          items[index];


        stopAllGalleryVideos(
          activeItem
        );


        items.forEach(
          (
            item,
            itemIndex
          ) => {

            const isActive =
              itemIndex === index;

            item.hidden =
              !isActive;

            item.classList.toggle(
              'is-active',
              isActive
            );


            /*
             * Eski animasyon class'ını
             * pasif itemlardan temizle.
             */
            if (!isActive) {
              item.classList.remove(
                'dekofar-v2-slide-in-right'
              );
            }
          }
        );


        /*
         * Sağdan giriş animasyonu.
         */
        if (
          options.animateFromRight
        ) {

          activeItem.classList.remove(
            'dekofar-v2-slide-in-right'
          );

          void activeItem.offsetWidth;

          activeItem.classList.add(
            'dekofar-v2-slide-in-right'
          );
        }


        const activeMediaId =
          activeItem.getAttribute(
            'data-media-id'
          );

        const activeMediaType =
          activeItem.getAttribute(
            'data-media-type'
          );


        setMainThumbnailState(
          activeMediaId,
          options.scrollThumbnail !== false
        );


        updateMainNav();


        /* -------------------------------------------------
           NORMAL VIDEO
           ------------------------------------------------- */

        if (
          activeMediaType ===
            'video' &&
          options.autoplayVideo
        ) {

          const normalVideo =
            activeItem.querySelector(
              'video'
            );

          playVideo(
            normalVideo,
            false
          );
        }


        /* -------------------------------------------------
           TEASER VIDEO
           ------------------------------------------------- */

        if (
          activeMediaType ===
          'teaser_video'
        ) {

          /*
           * Önce poster görünsün.
           */
          if (teaserPoster) {
            teaserPoster.hidden =
              false;
          }


          pauseVideo(
            teaserVideo,
            true
          );


          if (
            options.autoplayVideo !==
            false
          ) {

            if (teaserPosterTimeout) {
              clearTimeout(
                teaserPosterTimeout
              );
            }


            teaserPosterTimeout =
              setTimeout(() => {

                /*
                 * Bu sırada kullanıcı başka medyaya
                 * geçtiyse oynatma.
                 */
                if (
                  activeItem.hidden ||
                  teaserCancelled
                ) {
                  return;
                }


                if (teaserPoster) {
                  teaserPoster.hidden =
                    true;
                }


                playVideo(
                  teaserVideo,
                  true
                );

              }, TEASER_POSTER_DELAY_MS);
          }
        }


        return true;
      };


      const showMediaById = (
        mediaId,
        options = {}
      ) => {

        if (
          mediaId === null ||
          mediaId === undefined ||
          mediaId === ''
        ) {
          return false;
        }


        const index =
          items.findIndex(
            (item) =>

              item.getAttribute(
                'data-media-id'
              ) ===
              String(mediaId)
          );


        if (index === -1) {
          return false;
        }


        return showMediaByIndex(
          index,
          options
        );
      };


      /* =====================================================
         RETURN TO COVER
         ===================================================== */

      const returnToCover = () => {

        /*
         * Kullanıcı teaser başladıktan sonra
         * kendi medya/varyant seçimini yaptıysa
         * o seçimi bozma.
         */
        if (teaserCancelled) {
          return;
        }


        teaserFinished = true;

        clearTeaserTimers();

        pauseVideo(
          teaserVideo,
          true
        );


        if (teaserPoster) {
          teaserPoster.hidden =
            false;
        }


        /*
         * Öncelik Liquid'den gelen
         * kapak media ID.
         */
        if (
          firstMediaId &&
          showMediaById(
            firstMediaId,
            {
              autoplayVideo: false,
              scrollThumbnail: false,
              animateFromRight: true
            }
          )
        ) {
          return;
        }


        /*
         * firstMediaId yoksa ilk gerçek item.
         */
        showMediaByIndex(
          0,
          {
            autoplayVideo: false,
            scrollThumbnail: false,
            animateFromRight: true
          }
        );
      };


      /* =====================================================
         MAIN PREVIOUS / NEXT
         ===================================================== */

      const showPreviousMain = () => {

        if (currentIndex <= 0) {
          return;
        }


        cancelTeaser();


        if (
          showMediaByIndex(
            currentIndex - 1,
            {
              autoplayVideo: true
            }
          )
        ) {
          emphasizeMainNav();
        }
      };


      const showNextMain = () => {

        if (
          currentIndex >=
          items.length - 1
        ) {
          return;
        }


        cancelTeaser();


        if (
          showMediaByIndex(
            currentIndex + 1,
            {
              autoplayVideo: true
            }
          )
        ) {
          emphasizeMainNav();
        }
      };


      /* =====================================================
         MAIN THUMBNAIL CLICK
         ===================================================== */

      thumbnails.forEach(
        (thumbnail) => {

          thumbnail.addEventListener(
            'click',
            () => {

              cancelTeaser();


              showMediaById(
                thumbnail.getAttribute(
                  'data-media-id'
                ),
                {
                  autoplayVideo: true
                }
              );
            }
          );
        }
      );


      if (previousButton) {

        previousButton.addEventListener(
          'click',
          showPreviousMain
        );
      }


      if (nextButton) {

        nextButton.addEventListener(
          'click',
          showNextMain
        );
      }


      /* =====================================================
         LIGHTBOX THUMBNAIL STATE
         ===================================================== */

      const setLightboxThumbnailState = (
        mediaId
      ) => {

        lightboxThumbnails.forEach(
          (thumbnail) => {

            const isActive =
              thumbnail.getAttribute(
                'data-media-id'
              ) ===
              String(mediaId);


            thumbnail.classList.toggle(
              'is-active',
              isActive
            );


            thumbnail.setAttribute(
              'aria-current',
              isActive
                ? 'true'
                : 'false'
            );


            if (isActive) {

              try {
                thumbnail.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'center'
                });
              } catch (error) {}
            }
          }
        );


        requestAnimationFrame(() => {

          updateStripNav(
            lightboxThumbStrip,
            lightboxThumbPrev,
            lightboxThumbNext
          );
        });
      };


      /* =====================================================
         LIGHTBOX SHOW
         ===================================================== */

      const showLightboxByIndex = (
        index
      ) => {

        if (!lightboxItems.length) {
          return false;
        }


        /*
         * LOOP YOK.
         */
        if (
          index < 0 ||
          index >= lightboxItems.length
        ) {
          return false;
        }


        resetAllLightboxZoom();

        lightboxIndex = index;

        if (lightboxCurrentIndex) {
          lightboxCurrentIndex.textContent =
            String(index + 1);
        }

        const activeItem =
          lightboxItems[index];


        stopLightboxVideos(
          activeItem
        );


        lightboxItems.forEach(
          (
            item,
            itemIndex
          ) => {

            const isActive =
              itemIndex === index;

            item.hidden =
              !isActive;

            item.classList.toggle(
              'is-active',
              isActive
            );


            if (!isActive) {

              item.classList.remove(
                'dekofar-v2-lightbox-slide-in-right'
              );
            }
          }
        );


        /*
         * Lightbox medya
         * sağdan giriş animasyonu.
         */
        activeItem.classList.remove(
          'dekofar-v2-lightbox-slide-in-right'
        );

        void activeItem.offsetWidth;

        activeItem.classList.add(
          'dekofar-v2-lightbox-slide-in-right'
        );


        const mediaId =
          activeItem.getAttribute(
            'data-media-id'
          );

        const mediaType =
          activeItem.getAttribute(
            'data-media-type'
          );


        setLightboxThumbnailState(
          mediaId
        );


        updateLightboxNav();


        /* -------------------------------------------------
           LIGHTBOX NORMAL VIDEO
           ------------------------------------------------- */

        if (
          mediaType === 'video'
        ) {

          playVideo(
            activeItem.querySelector(
              'video'
            ),
            false
          );
        }


        /* -------------------------------------------------
           LIGHTBOX TEASER VIDEO
           ------------------------------------------------- */

        if (
          mediaType ===
          'teaser_video'
        ) {

          const video =
            activeItem.querySelector(
              'video'
            );

          const poster =
            activeItem.querySelector(
              '[data-dekofar-v2-lightbox-teaser-poster]'
            );


          if (video) {

            try {
              video.muted = true;
              video.defaultMuted = true;
              video.playsInline = true;

              video.setAttribute(
                'muted',
                ''
              );

              video.setAttribute(
                'playsinline',
                ''
              );
            } catch (error) {}
          }


          if (poster) {
            poster.hidden =
              false;
          }


          pauseVideo(
            video,
            true
          );


          setTimeout(() => {

            if (activeItem.hidden) {
              return;
            }


            if (poster) {
              poster.hidden =
                true;
            }


            playVideo(
              video,
              true
            );

          }, 220);
        }


        return true;
      };


      const showLightboxByMediaId = (
        mediaId
      ) => {

        if (
          mediaId === null ||
          mediaId === undefined ||
          mediaId === ''
        ) {
          return false;
        }


        const index =
          lightboxItems.findIndex(
            (item) =>

              item.getAttribute(
                'data-media-id'
              ) ===
              String(mediaId)
          );


        if (index === -1) {
          return false;
        }


        return showLightboxByIndex(
          index
        );
      };


      /* =====================================================
         OPEN LIGHTBOX
         ===================================================== */

      const openLightbox = (
        mediaId,
        trigger = null
      ) => {

        if (
          !lightbox ||
          !lightboxItems.length
        ) {
          return;
        }


        lastLightboxTrigger =
          trigger ||
          document.activeElement;


        /*
         * Kullanıcı lightbox açtı.
         * Otomatik teaser artık ana galeriyi
         * değiştirmesin.
         */
        cancelTeaser();


        pauseVideo(
          teaserVideo,
          false
        );


        if (
          !showLightboxByMediaId(
            mediaId
          )
        ) {

          showLightboxByIndex(
            0
          );
        }


        lightbox.hidden =
          false;


        document.documentElement
          .classList.add(
            'dekofar-v2-lightbox-open'
          );


        const closeButton =
          lightbox.querySelector(
            '.dekofar-v2-gallery-lightbox__close[data-dekofar-v2-lightbox-close]'
          );


        if (closeButton) {

          requestAnimationFrame(() => {

            try {
              closeButton.focus({
                preventScroll: true
              });
            } catch (error) {}
          });
        }
      };


      /* =====================================================
         CLOSE LIGHTBOX
         ===================================================== */

      const closeLightbox = () => {

        if (!lightbox) {
          return;
        }


        stopLightboxVideos();

        resetAllLightboxZoom();


        lightbox.hidden =
          true;


        document.documentElement
          .classList.remove(
            'dekofar-v2-lightbox-open'
          );


        if (
          lastLightboxTrigger &&
          typeof lastLightboxTrigger.focus ===
            'function'
        ) {

          requestAnimationFrame(() => {

            try {

              lastLightboxTrigger.focus({
                preventScroll: true
              });

            } catch (error) {}
          });
        }
      };


      /* =====================================================
         LIGHTBOX OPEN BUTTONS
         ===================================================== */

      lightboxOpenButtons.forEach(
        (button) => {

          button.addEventListener(
            'click',
            (event) => {

              if (
                button.dataset
                  .dekofarSuppressClick ===
                'true'
              ) {

                delete button.dataset
                  .dekofarSuppressClick;

                event.preventDefault();
                event.stopPropagation();

                return;
              }


              event.stopPropagation();


              openLightbox(
                button.getAttribute(
                  'data-media-id'
                ),
                button
              );
            }
          );
        }
      );


      mobileDots.forEach(
        (dot) => {
          dot.addEventListener(
            'click',
            () => {
              showMediaById(
                dot.getAttribute(
                  'data-media-id'
                ),
                {
                  autoplayVideo: true,
                  scrollThumbnail: false
                }
              );
            }
          );
        }
      );


      /* =====================================================
         INDEPENDENT REELS VIDEO
         ===================================================== */

      const reelsProductId =
        reels
          ? reels.getAttribute(
              'data-product-id'
            ) || 'product'
          : 'product';

      const reelsStoragePrefix =
        `dekofar:v2:reels:${reelsProductId}`;

      const reelsSpeeds =
        [1, 1.25, 1.5, 2];

      let reelsViewCountValue =
        reels
          ? parseInt(
              reels.getAttribute(
                'data-initial-view-count'
              ) || '1250',
              10
            )
          : 1250;

      let reelsSpeedIndex = 0;
      let reelsViewCountedThisOpen = false;


      const readStorage = (
        key
      ) => {
        try {
          return window.localStorage.getItem(
            key
          );
        } catch (error) {
          return null;
        }
      };


      const writeStorage = (
        key,
        value
      ) => {
        try {
          window.localStorage.setItem(
            key,
            String(value)
          );
        } catch (error) {}
      };


      const formatReelsCount = (
        value
      ) => {
        return new Intl.NumberFormat(
          'tr-TR'
        ).format(
          Number(value) || 0
        );
      };


      const showReelsMessage = (
        message,
        isError = false
      ) => {
        if (!reelsMessage) {
          return;
        }

        reelsMessage.textContent =
          message || '';

        reelsMessage.hidden =
          !message;

        reelsMessage.classList.toggle(
          'is-error',
          Boolean(isError)
        );
      };


      const updateReelsReaction = (
        reaction
      ) => {
        const normalized =
          reaction === 'like' ||
          reaction === 'dislike'
            ? reaction
            : '';

        if (reelsLikeButton) {
          reelsLikeButton.setAttribute(
            'aria-pressed',
            normalized === 'like'
              ? 'true'
              : 'false'
          );
        }

        if (reelsDislikeButton) {
          reelsDislikeButton.setAttribute(
            'aria-pressed',
            normalized === 'dislike'
              ? 'true'
              : 'false'
          );
        }

        writeStorage(
          `${reelsStoragePrefix}:reaction`,
          normalized
        );
      };


      const updateReelsViewCount = () => {
        if (reelsViewCount) {
          reelsViewCount.textContent =
            formatReelsCount(
              reelsViewCountValue
            );
        }
      };


      const syncReelsCartState = (
        variant = null
      ) => {
        if (!reelsAddToCartButton) {
          return;
        }

        const mainButton =
          productRoot
            ? productRoot.querySelector(
                '[data-dekofar-v2-add-to-cart]'
              )
            : null;

        const available =
          variant
            ? Boolean(variant.available)
            : Boolean(
                mainButton &&
                !mainButton.disabled
              );

        reelsAddToCartButton.disabled =
          !available;

        reelsAddToCartButton.textContent =
          available
            ? 'Sepete Ekle'
            : 'Tükendi';
      };


      const incrementReelsView = () => {
        if (reelsViewCountedThisOpen) {
          return;
        }

        reelsViewCountedThisOpen = true;

        const randomIncrease =
          Math.floor(
            Math.random() * 4
          ) + 1;

        reelsViewCountValue +=
          randomIncrease;

        writeStorage(
          `${reelsStoragePrefix}:views`,
          reelsViewCountValue
        );

        updateReelsViewCount();
      };


      const closeReels = () => {
        if (!reels) {
          return;
        }

        if (reelsViewTimer) {
          clearTimeout(
            reelsViewTimer
          );
          reelsViewTimer = null;
        }

        pauseVideo(
          reelsVideo,
          true
        );

        reels.hidden = true;

        document.documentElement.classList.remove(
          'dekofar-v2-reels-open'
        );

        if (
          lastReelsTrigger &&
          typeof lastReelsTrigger.focus ===
            'function'
        ) {
          try {
            lastReelsTrigger.focus({
              preventScroll: true
            });
          } catch (error) {}
        }
      };


      const openReels = (
        trigger = null
      ) => {
        if (
          !reels ||
          !reelsVideo
        ) {
          return;
        }

        lastReelsTrigger =
          trigger ||
          document.activeElement;

        reelsViewCountedThisOpen =
          false;

        showReelsMessage('');
        syncReelsCartState();

        reels.hidden = false;

        document.documentElement.classList.add(
          'dekofar-v2-reels-open'
        );

        /* Sade Reels her açılışta normal hızda oynar. */
        reelsVideo.playbackRate = 1;

        const playPromise =
          reelsVideo.play();

        if (
          playPromise &&
          typeof playPromise.catch ===
            'function'
        ) {
          playPromise.catch(() => {});
        }
      };


      if (reels) {
        const storedViews =
          parseInt(
            readStorage(
              `${reelsStoragePrefix}:views`
            ) || '',
            10
          );

        if (
          Number.isFinite(storedViews) &&
          storedViews >= reelsViewCountValue
        ) {
          reelsViewCountValue =
            storedViews;
        }

        const storedReaction =
          readStorage(
            `${reelsStoragePrefix}:reaction`
          ) || '';

        const storedSpeed =
          Number(
            readStorage(
              'dekofar:v2:reels:speed'
            )
          );

        const matchingSpeedIndex =
          reelsSpeeds.indexOf(
            storedSpeed
          );

        if (matchingSpeedIndex >= 0) {
          reelsSpeedIndex =
            matchingSpeedIndex;
        }

        updateReelsViewCount();
        updateReelsReaction(
          storedReaction
        );
        syncReelsCartState();

        if (reelsSpeedButton) {
          reelsSpeedButton.textContent =
            `${reelsSpeeds[reelsSpeedIndex]}x`;
        }
      }


      if (videoButton) {
        videoButton.addEventListener(
          'click',
          () => {
            openReels(
              videoButton
            );
          }
        );
      }


      reelsCloseButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            closeReels
          );
        }
      );


      if (reelsVideo) {
        reelsVideo.addEventListener(
          'playing',
          () => {
            if (reelsViewTimer) {
              clearTimeout(
                reelsViewTimer
              );
            }

            reelsViewTimer =
              setTimeout(
                incrementReelsView,
                3000
              );
          }
        );

        reelsVideo.addEventListener(
          'pause',
          () => {
            if (
              reelsViewTimer &&
              !reelsViewCountedThisOpen
            ) {
              clearTimeout(
                reelsViewTimer
              );
              reelsViewTimer = null;
            }
          }
        );
      }


      if (reelsLikeButton) {
        reelsLikeButton.addEventListener(
          'click',
          () => {
            const isActive =
              reelsLikeButton.getAttribute(
                'aria-pressed'
              ) === 'true';

            updateReelsReaction(
              isActive
                ? ''
                : 'like'
            );
          }
        );
      }


      if (reelsDislikeButton) {
        reelsDislikeButton.addEventListener(
          'click',
          () => {
            const isActive =
              reelsDislikeButton.getAttribute(
                'aria-pressed'
              ) === 'true';

            updateReelsReaction(
              isActive
                ? ''
                : 'dislike'
            );
          }
        );
      }


      if (reelsSpeedButton) {
        reelsSpeedButton.addEventListener(
          'click',
          () => {
            reelsSpeedIndex =
              (
                reelsSpeedIndex + 1
              ) % reelsSpeeds.length;

            const speed =
              reelsSpeeds[
                reelsSpeedIndex
              ];

            if (reelsVideo) {
              reelsVideo.playbackRate =
                speed;
            }

            reelsSpeedButton.textContent =
              `${speed}x`;

            writeStorage(
              'dekofar:v2:reels:speed',
              speed
            );
          }
        );
      }


      if (reelsShareButton) {
        reelsShareButton.addEventListener(
          'click',
          async () => {
            const shareData = {
              title: document.title,
              text: document.title,
              url: window.location.href
            };

            try {
              if (navigator.share) {
                await navigator.share(
                  shareData
                );
              } else if (
                navigator.clipboard &&
                navigator.clipboard.writeText
              ) {
                await navigator.clipboard.writeText(
                  window.location.href
                );

                showReelsMessage(
                  'Ürün bağlantısı kopyalandı.'
                );
              }
            } catch (error) {}
          }
        );
      }


      if (reelsAddToCartButton) {
        reelsAddToCartButton.addEventListener(
          'click',
          () => {
            const mainButton =
              productRoot
                ? productRoot.querySelector(
                    '[data-dekofar-v2-add-to-cart]'
                  )
                : null;

            if (
              !mainButton ||
              mainButton.disabled
            ) {
              showReelsMessage(
                'Bu varyant şu anda satın alınamıyor.',
                true
              );
              return;
            }

            showReelsMessage(
              'Ürün sepete ekleniyor…'
            );

            mainButton.click();

            setTimeout(
              closeReels,
              350
            );
          }
        );
      }

      if (reelsInspectProductButton) {
        reelsInspectProductButton.addEventListener(
          'click',
          () => {
            const root = productRoot || document;
            const target =
              root.querySelector(
                '[data-dekofar-v2-product-modules], .dekofar-v2-product-modules'
              ) ||
              root.querySelector(
                '.dekofar-v2-product-ui__main + *'
              );

            closeReels();

            if (!target) {
              return;
            }

            window.requestAnimationFrame(() => {
              try {
                target.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              } catch (error) {
                target.scrollIntoView();
              }
            });
          }
        );
      }


      /* =====================================================
         MOBILE "TÜM ÖZELLİKLER" BUTTON
         ===================================================== */

      if (featuresButton) {
        featuresButton.addEventListener(
          'click',
          () => {
            const root =
              productRoot || document;

            const target =
              root.querySelector(
                '[data-dekofar-v2-product-modules], .dekofar-v2-product-modules'
              ) ||
              root.querySelector(
                '.dekofar-v2-product-ui__main + *'
              );

            if (!target) {
              return;
            }

            try {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            } catch (error) {
              target.scrollIntoView();
            }
          }
        );
      }


      /* =====================================================
         LIGHTBOX THUMBNAILS
         ===================================================== */

      lightboxThumbnails.forEach(
        (thumbnail) => {

          thumbnail.addEventListener(
            'click',
            () => {

              showLightboxByMediaId(
                thumbnail.getAttribute(
                  'data-media-id'
                )
              );
            }
          );
        }
      );


      /* =====================================================
         LIGHTBOX PREVIOUS / NEXT
         ===================================================== */

      if (lightboxPreviousButton) {

        lightboxPreviousButton
          .addEventListener(
            'click',
            () => {

              if (
                showLightboxByIndex(
                  lightboxIndex - 1
                )
              ) {

                emphasizeLightboxNav();
              }
            }
          );
      }


      if (lightboxNextButton) {

        lightboxNextButton
          .addEventListener(
            'click',
            () => {

              if (
                showLightboxByIndex(
                  lightboxIndex + 1
                )
              ) {

                emphasizeLightboxNav();
              }
            }
          );
      }


      /* =====================================================
         LIGHTBOX CLOSE BUTTONS
         ===================================================== */

      lightboxCloseButtons.forEach(
        (button) => {

          button.addEventListener(
            'click',
            (event) => {

              event.stopPropagation();

              closeLightbox();
            }
          );
        }
      );


      /* =====================================================
         LIGHTBOX EMPTY AREA CLOSE
         ===================================================== */

      if (lightbox) {

        lightbox.addEventListener(
          'click',
          (event) => {

            const target =
              event.target;


            /*
             * HEADER
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__header'
              )
            ) {
              return;
            }


            /*
             * IMAGE
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__image'
              )
            ) {
              return;
            }


            /*
             * VIDEO
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__video'
              )
            ) {
              return;
            }


            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__video-item'
              )
            ) {
              return;
            }


            /*
             * THUMBNAIL
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__thumbnail'
              )
            ) {
              return;
            }


            /*
             * MAIN NAV
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__nav'
              )
            ) {
              return;
            }


            /*
             * THUMB NAV
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__thumb-nav'
              )
            ) {
              return;
            }


            /*
             * CLOSE
             */
            if (
              target.closest(
                '.dekofar-v2-gallery-lightbox__close'
              )
            ) {
              return;
            }


            /*
             * Boş alana tıklandıysa kapat.
             */
            if (
              target.classList.contains(
                'dekofar-v2-gallery-lightbox__backdrop'
              ) ||
              target.classList.contains(
                'dekofar-v2-gallery-lightbox__stage'
              ) ||
              target.classList.contains(
                'dekofar-v2-gallery-lightbox__dialog'
              )
            ) {

              closeLightbox();
            }
          }
        );
      }


      /* =====================================================
         SWIPE HELPER
         ===================================================== */

      const bindHorizontalSwipe = (
        element,
        previousCallback,
        nextCallback,
        canSwipeCallback = null,
        onSwipe = null
      ) => {

        if (!element) {
          return;
        }


        let startX = 0;
        let startY = 0;

        let tracking = false;
        let didSwipe = false;

        const minimumDistance =
          42;


        element.addEventListener(
          'pointerdown',
          (event) => {

            if (
              event.pointerType ===
                'mouse' &&
              event.button !== 0
            ) {
              return;
            }


            if (
              event.target.closest(
                'input, select, textarea, video'
              )
            ) {
              return;
            }


            if (
              canSwipeCallback &&
              !canSwipeCallback()
            ) {
              return;
            }


            tracking = true;
            didSwipe = false;

            startX =
              event.clientX;

            startY =
              event.clientY;
          }
        );


        element.addEventListener(
          'pointerup',
          (event) => {

            if (!tracking) {
              return;
            }


            tracking = false;


            if (
              canSwipeCallback &&
              !canSwipeCallback()
            ) {
              return;
            }


            const diffX =
              event.clientX -
              startX;

            const diffY =
              event.clientY -
              startY;


            if (
              Math.abs(diffX) <
              minimumDistance
            ) {
              return;
            }


            if (
              Math.abs(diffX) <=
              Math.abs(diffY)
            ) {
              return;
            }


            didSwipe = true;


            event.preventDefault();


            if (diffX < 0) {

              nextCallback();

            } else {

              previousCallback();
            }


            if (onSwipe) {
              onSwipe();
            }
          }
        );


        element.addEventListener(
          'pointercancel',
          () => {

            tracking = false;
            didSwipe = false;
          }
        );


        element.addEventListener(
          'click',
          (event) => {

            if (!didSwipe) {
              return;
            }


            event.preventDefault();
            event.stopPropagation();

            didSwipe = false;

          },
          true
        );
      };


      /* =====================================================
         MAIN SWIPE
         ===================================================== */

      bindHorizontalSwipe(
        mainSwipeArea,
        showPreviousMain,
        showNextMain,
        () => !isAnyMainZoomed(),
        emphasizeMainNav
      );


      /* =====================================================
         LIGHTBOX SWIPE
         ===================================================== */

      bindHorizontalSwipe(
        lightboxSwipeArea,

        () => {

          if (
            showLightboxByIndex(
              lightboxIndex - 1
            )
          ) {
            emphasizeLightboxNav();
          }
        },

        () => {

          if (
            showLightboxByIndex(
              lightboxIndex + 1
            )
          ) {
            emphasizeLightboxNav();
          }
        },

        () =>
          !isAnyLightboxZoomed(),

        null
      );


      /* =====================================================
         PINCH ZOOM + PAN
         ===================================================== */

      function createTouchZoomController(
        shell,
        maxScale,
        options = {}
      ) {

        if (!shell) {
          return null;
        }


        let scale = 1;
        let startScale = 1;

        let startDistance = 0;

        let translateX = 0;
        let translateY = 0;

        let startTranslateX = 0;
        let startTranslateY = 0;

        let panStartX = 0;
        let panStartY = 0;

        let pinching = false;
        let panning = false;
        let moved = false;


        const clamp = (
          value,
          min,
          max
        ) =>
          Math.min(
            max,
            Math.max(
              min,
              value
            )
          );


        const distance = (
          touches
        ) => {

          const dx =
            touches[0].clientX -
            touches[1].clientX;

          const dy =
            touches[0].clientY -
            touches[1].clientY;


          return Math.hypot(
            dx,
            dy
          );
        };


        const render = () => {

          shell.style.transform =
            `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
        };


        const reset = (
          animate = true
        ) => {

          scale = 1;
          startScale = 1;

          translateX = 0;
          translateY = 0;

          startTranslateX = 0;
          startTranslateY = 0;

          pinching = false;
          panning = false;


          if (animate) {

            shell.style.transition =
              'transform .2s ease';

            render();


            setTimeout(() => {

              shell.style.transition =
                '';

            }, 220);

          } else {

            shell.style.transition =
              '';

            render();
          }
        };


        const isZoomed = () =>
          scale > 1.01;


        shell.addEventListener(
          'touchstart',
          (event) => {

            moved = false;


            if (
              event.touches.length ===
              2
            ) {

              pinching = true;
              panning = false;


              startDistance =
                distance(
                  event.touches
                );


              startScale =
                scale;


              startTranslateX =
                translateX;

              startTranslateY =
                translateY;


              return;
            }


            if (
              event.touches.length ===
                1 &&
              isZoomed()
            ) {

              panning = true;
              pinching = false;


              panStartX =
                event.touches[0]
                  .clientX;

              panStartY =
                event.touches[0]
                  .clientY;


              startTranslateX =
                translateX;

              startTranslateY =
                translateY;
            }
          },
          {
            passive: true
          }
        );


        shell.addEventListener(
          'touchmove',
          (event) => {

            /*
             * PINCH
             */
            if (
              event.touches.length ===
                2 &&
              pinching
            ) {

              event.preventDefault();

              moved = true;


              const nextDistance =
                distance(
                  event.touches
                );


              if (!startDistance) {
                return;
              }


              scale =
                clamp(
                  startScale *
                  (
                    nextDistance /
                    startDistance
                  ),
                  1,
                  maxScale
                );


              if (
                scale <= 1.01
              ) {

                translateX = 0;
                translateY = 0;
              }


              render();

              return;
            }


            /*
             * PAN
             */
            if (
              event.touches.length ===
                1 &&
              panning &&
              isZoomed()
            ) {

              event.preventDefault();

              moved = true;


              const dx =
                event.touches[0]
                  .clientX -
                panStartX;


              const dy =
                event.touches[0]
                  .clientY -
                panStartY;


              const rect =
                shell.getBoundingClientRect();


              const maxX =
                Math.max(
                  0,
                  (
                    rect.width *
                    (scale - 1)
                  ) /
                  (
                    2 *
                    scale
                  )
                );


              const maxY =
                Math.max(
                  0,
                  (
                    rect.height *
                    (scale - 1)
                  ) /
                  (
                    2 *
                    scale
                  )
                );


              translateX =
                clamp(
                  startTranslateX +
                    dx,
                  -maxX,
                  maxX
                );


              translateY =
                clamp(
                  startTranslateY +
                    dy,
                  -maxY,
                  maxY
                );


              render();
            }
          },
          {
            passive: false
          }
        );


        shell.addEventListener(
          'touchend',
          (event) => {

            if (
              event.touches.length <
              2
            ) {
              pinching = false;
            }


            if (
              event.touches.length ===
              0
            ) {
              panning = false;
            }


            if (
              scale <= 1.01
            ) {
              reset(true);
            }


            if (
              moved &&
              options.openButton
            ) {

              options.openButton
                .dataset
                .dekofarSuppressClick =
                'true';
            }
          },
          {
            passive: true
          }
        );


        /*
         * Mobil çift dokunma /
         * dblclick fallback.
         */
        shell.addEventListener(
          'dblclick',
          (event) => {

            if (
              'ontouchstart' in window
            ) {

              event.preventDefault();


              if (isZoomed()) {

                reset(true);

              } else {

                scale =
                  Math.min(
                    2,
                    maxScale
                  );

                translateX = 0;
                translateY = 0;

                render();
              }
            }
          }
        );


        return {
          reset,
          isZoomed
        };
      }


      /* =====================================================
         MAIN ZOOM
         ===================================================== */

      gallery
        .querySelectorAll(
          '[data-dekofar-v2-main-zoom-shell]'
        )
        .forEach((shell) => {

          const button =
            shell.closest(
              '[data-dekofar-v2-lightbox-open]'
            );


          const controller =
            createTouchZoomController(
              shell,
              3,
              {
                openButton: button
              }
            );


          if (controller) {

            mainZoomControllers.push(
              controller
            );
          }
        });


      /* =====================================================
         LIGHTBOX ZOOM
         ===================================================== */

      gallery
        .querySelectorAll(
          '[data-dekofar-v2-lightbox-zoom-shell]'
        )
        .forEach((shell) => {

          const controller =
            createTouchZoomController(
              shell,
              4
            );


          if (controller) {

            lightboxZoomControllers.push(
              controller
            );
          }
        });


      /* =====================================================
         MODAL PORTAL

         Tema içindeki grid/transform/stacking-context katmanları,
         position:fixed ve yüksek z-index değerine rağmen ürün
         bilgilerinin modalın üzerine çıkmasına neden olabilir.

         Bütün lightbox elemanları ve olay referansları hazırlandıktan
         sonra lightbox ile Reels doğrudan document.body altına taşınır.
         Böylece her iki pencere de tema sütunlarından tamamen bağımsızdır.
         ===================================================== */

      const portalModalToBody = (
        modal,
        modalType
      ) => {
        if (
          !modal ||
          !document.body
        ) {
          return;
        }

        if (
          modal.parentElement ===
          document.body
        ) {
          return;
        }

        modal.setAttribute(
          'data-dekofar-v2-portaled',
          modalType
        );

        modal.setAttribute(
          'data-dekofar-v2-owner-gallery',
          gallery.getAttribute(
            'data-first-media-id'
          ) || ''
        );

        document.body.appendChild(
          modal
        );
      };


      portalModalToBody(
        lightbox,
        'lightbox'
      );

      portalModalToBody(
        reels,
        'reels'
      );


      /* =====================================================
         KEYBOARD
         ===================================================== */

      const keyboardHandler = (
        event
      ) => {

        if (
          reels &&
          !reels.hidden
        ) {
          if (
            event.key ===
            'Escape'
          ) {
            closeReels();
          }

          return;
        }

        if (
          !lightbox ||
          lightbox.hidden
        ) {
          return;
        }


        if (
          event.key ===
          'Escape'
        ) {

          closeLightbox();

          return;
        }


        if (
          event.key ===
          'ArrowLeft'
        ) {

          event.preventDefault();


          if (
            showLightboxByIndex(
              lightboxIndex - 1
            )
          ) {

            emphasizeLightboxNav();
          }


          return;
        }


        if (
          event.key ===
          'ArrowRight'
        ) {

          event.preventDefault();


          if (
            showLightboxByIndex(
              lightboxIndex + 1
            )
          ) {

            emphasizeLightboxNav();
          }
        }
      };


      document.addEventListener(
        'keydown',
        keyboardHandler
      );


      /* =====================================================
         TEASER START
         ===================================================== */

      const startTeaserVideo = () => {

        /*
         * Kullanıcı bu 2 saniye içinde
         * bir işlem yaptıysa teaser açılmaz.
         */
        if (
          teaserCancelled ||
          teaserStarted ||
          teaserFinished ||
          !hasTeaserVideo ||
          !teaserItem ||
          !teaserVideo
        ) {
          return;
        }


        const teaserMediaId =
          teaserItem.getAttribute(
            'data-media-id'
          );


        if (!teaserMediaId) {
          return;
        }


        /*
         * Önce started=true yapıyoruz;
         * iki defa tetiklenmesini engeller.
         */
        teaserStarted = true;


        /*
         * Teaser item görünür hale gelir.
         * showMediaByIndex içinde video
         * otomatik çalıştırılır.
         */
        const didShow =
          showMediaById(
            teaserMediaId,
            {
              autoplayVideo: true,
              scrollThumbnail: false
            }
          );


        if (!didShow) {

          teaserStarted = false;

          return;
        }
      };


      /* =====================================================
         TEASER EVENTS
         ===================================================== */

      if (
        hasTeaserVideo &&
        teaserItem &&
        teaserVideo
      ) {

        /*
         * Video bittiğinde kapak görseline dön.
         */
        teaserVideo.addEventListener(
          'ended',
          () => {

            if (teaserCancelled) {
              return;
            }

            returnToCover();
          }
        );


        /*
         * Video hata verirse galeri
         * teaser'da takılı kalmasın.
         */
        teaserVideo.addEventListener(
          'error',
          () => {

            if (teaserCancelled) {
              return;
            }

            returnToCover();
          }
        );


        /*
         * Video gerçekten oynamaya başladığında
         * poster kesinlikle kapansın.
         */
        teaserVideo.addEventListener(
          'playing',
          () => {

            if (
              teaserCancelled
            ) {
              return;
            }


            if (teaserPoster) {

              teaserPoster.hidden =
                true;
            }
          }
        );


        /*
         * Video tekrar beklemeye girerse
         * poster açmıyoruz.
         * Çünkü kısa buffering'de beyaz ekran
         * yanıp sönmesin.
         */


        /*
         * Otomatik teaser bilinçli olarak kapalıdır.
         * Video yalnızca kullanıcı
         * "Ürün Videosunu İzle" butonuna basınca açılır.
         */
      }


      /* =====================================================
         INITIAL MEDIA

         ÇOK ÖNEMLİ:
         Teaser başlamadan önce ilk ekranda
         KAPAK görseli kalır.
         ===================================================== */

      let initialMediaWasShown =
        false;


      /*
       * data-first-media-id varsa
       * doğrudan kapak medyayı göster.
       */
      if (firstMediaId) {

        initialMediaWasShown =
          showMediaById(
            firstMediaId,
            {
              autoplayVideo: false,
              scrollThumbnail: false
            }
          );
      }


      /*
       * data-first-media-id bulunamazsa
       * ilk item fallback.
       */
      if (!initialMediaWasShown) {

        showMediaByIndex(
          0,
          {
            autoplayVideo: false,
            scrollThumbnail: false
          }
        );
      }


      updateMainNav();
      updateLightboxNav();


      /* =====================================================
         VARIANT-AWARE SHIPPING BADGES
         ===================================================== */

      const updateShippingBadges = (
        variant
      ) => {

        if (
          !variant ||
          !galleryVariantData ||
          !galleryVariantData.variants
        ) {
          return;
        }

        const state =
          galleryVariantData.variants[
            String(variant.id)
          ];

        if (!state) {
          return;
        }

        const showFreeShipping =
          state.freeShipping === true;

        const showSameDayShipping =
          state.sameDayShipping === true;

        if (freeShippingBadge) {
          freeShippingBadge.hidden =
            !showFreeShipping;
        }

        if (sameDayShippingBadge) {
          sameDayShippingBadge.hidden =
            !showSameDayShipping;
        }

        if (shippingBadges) {
          shippingBadges.hidden =
            !showFreeShipping &&
            !showSameDayShipping;
        }
      };


      const updateShippingBadgesByVariantId = (
        variantId
      ) => {

        if (
          variantId === undefined ||
          variantId === null ||
          variantId === ''
        ) {
          return;
        }

        updateShippingBadges(
          {
            id: String(
              variantId
            )
          }
        );
      };


      if (productRoot) {
        const variantInput =
          productRoot.querySelector(
            '[data-dekofar-v2-variant-id]'
          );

        if (variantInput) {
          variantInput.addEventListener(
            'change',
            () => {
              updateShippingBadgesByVariantId(
                variantInput.value
              );
            }
          );

          updateShippingBadgesByVariantId(
            variantInput.value
          );
        }

        productRoot.addEventListener(
          'dekofar:v2:variant-change',
          (event) => {
            const variant =
              event.detail &&
              event.detail.variant
                ? event.detail.variant
                : null;

            updateShippingBadges(
              variant
            );

            syncReelsCartState(
              variant
            );
          }
        );
      }


      /* =====================================================
         PUBLIC API
         ===================================================== */

      /*
       * options:
       *
       * cancelTeaser:
       * true  -> kullanıcı aksiyonu,
       *          teaser iptal edilir.
       *
       * false -> sistem içi gösterim,
       *          teaser planı korunur.
       */
      gallery.dekofarV2ShowMedia = (
        mediaId,
        options = {}
      ) => {

        const shouldCancelTeaser =
          options.cancelTeaser !==
          false;


        if (shouldCancelTeaser) {

          cancelTeaser();
        }


        return showMediaById(
          mediaId,
          options
        );
      };


      gallery.dekofarV2CancelTeaser =
        cancelTeaser;


      gallery.dekofarV2CloseLightbox =
        closeLightbox;

    });
}


/* =========================================================
   DESCRIPTION-BELOW LAZY PRODUCT VIDEO

   - Kaynakları alana yaklaşınca yükler
   - Görünürken sessiz oynatır
   - Görünümden çıkınca durdurur
   - Tıklanınca mevcut Reels modalını sesli açar
========================================================= */

function dekofarV2InitScrollProductVideos(
  scope
) {

  const root =
    scope || document;

  root
    .querySelectorAll(
      '[data-dekofar-v2-scroll-video]'
    )
    .forEach(
      (section) => {

        if (
          section.dataset.dekofarV2ScrollVideoInitialized ===
          'true'
        ) {
          return;
        }

        const video =
          section.querySelector(
            '[data-dekofar-v2-scroll-video-player]'
          );

        const openButton =
          section.querySelector(
            '[data-dekofar-v2-scroll-video-open]'
          );

        if (
          !video ||
          !openButton
        ) {
          return;
        }

        section.dataset.dekofarV2ScrollVideoInitialized =
          'true';

        let sourcesLoaded =
          false;

        const loadSources = () => {

          if (
            sourcesLoaded
          ) {
            return;
          }

          const sources = [
            ...video.querySelectorAll(
              'source[data-src]'
            )
          ];

          sources.forEach(
            (source) => {

              const sourceUrl =
                source.getAttribute(
                  'data-src'
                );

              if (
                !sourceUrl
              ) {
                return;
              }

              source.setAttribute(
                'src',
                sourceUrl
              );

              source.removeAttribute(
                'data-src'
              );
            }
          );

          sourcesLoaded =
            true;

          video.load();
        };

        const playPreview = () => {

          loadSources();

          video.muted =
            true;

          video.defaultMuted =
            true;

          video.playsInline =
            true;

          video.setAttribute(
            'muted',
            ''
          );

          const playPromise =
            video.play();

          if (
            playPromise &&
            typeof playPromise.catch ===
              'function'
          ) {
            playPromise.catch(
              () => {}
            );
          }
        };

        const pausePreview = () => {
          try {
            video.pause();
          } catch (error) {}
        };

        if (
          'IntersectionObserver' in window
        ) {

          const loadObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  (entry) => {
                    if (
                      entry.isIntersecting
                    ) {
                      loadSources();
                      loadObserver.unobserve(
                        section
                      );
                    }
                  }
                );
              },
              {
                root: null,
                rootMargin: '500px 0px',
                threshold: 0
              }
            );

          const playbackObserver =
            new IntersectionObserver(
              (entries) => {
                entries.forEach(
                  (entry) => {
                    if (
                      entry.isIntersecting &&
                      entry.intersectionRatio >= 0.28
                    ) {
                      playPreview();
                    } else {
                      pausePreview();
                    }
                  }
                );
              },
              {
                root: null,
                threshold: [
                  0,
                  0.28,
                  0.6
                ]
              }
            );

          loadObserver.observe(
            section
          );

          playbackObserver.observe(
            section
          );

        } else {

          loadSources();
        }

        openButton.addEventListener(
          'click',
          () => {

            pausePreview();

            const productRoot =
              section.closest(
                '[data-dekofar-v2-product]'
              );

            const reelsTrigger =
              productRoot
                ? productRoot.querySelector(
                    '[data-dekofar-v2-video-button]'
                  )
                : null;

            if (
              !reelsTrigger
            ) {
              return;
            }

            reelsTrigger.click();

            const productId =
              section.getAttribute(
                'data-product-id'
              );

            let reelsVideo =
              productRoot.querySelector(
                '[data-dekofar-v2-reels-video]'
              );

            if (
              !reelsVideo &&
              productId
            ) {
              reelsVideo =
                document.querySelector(
                  `[data-dekofar-v2-reels][data-product-id="${productId}"] [data-dekofar-v2-reels-video]`
                );
            }

            if (
              !reelsVideo
            ) {
              return;
            }

            try {
              reelsVideo.muted =
                false;

              reelsVideo.defaultMuted =
                false;

              reelsVideo.removeAttribute(
                'muted'
              );

              reelsVideo.volume =
                1;

              reelsVideo.currentTime =
                0;

              const reelsPlayPromise =
                reelsVideo.play();

              if (
                reelsPlayPromise &&
                typeof reelsPlayPromise.catch ===
                  'function'
              ) {
                reelsPlayPromise.catch(
                  () => {}
                );
              }
            } catch (error) {}
          }
        );
      }
    );
}


/* =========================================================
   VARIANT FEATURED MEDIA -> GALLERY SYNC

   FINAL DAVRANIŞ:

   - Sayfa ilk açıldığında ürünün KAPAK / ilk medyası görünür.
   - Sayfa açılışında Core tarafından otomatik gönderilen
     variant-change eventleri galeriyi DEĞİŞTİRMEZ.
   - Kullanıcı gerçekten RENK veya PAKET kartına tıklarsa
     sistem aktif hale gelir.
   - Bundan sonra seçilen varyantın featured media görseli
     galeride gösterilir.
   - Kullanıcı başka varyanta geçtikçe görsel değişmeye devam eder.
========================================================= */

function dekofarV2InitVariantGallerySync(
  scope
) {

  const root =
    scope || document;


  root
    .querySelectorAll(
      '.dekofar-v2-product'
    )
    .forEach(
      (productRoot) => {


        /* =====================================================
           INIT GUARD
        ===================================================== */

        if (
          productRoot.dataset
            .dekofarV2GallerySyncInitialized ===
          'true'
        ) {

          return;
        }



        /* =====================================================
           GALLERY
        ===================================================== */

        const gallery =
          productRoot.querySelector(
            '[data-dekofar-v2-gallery]'
          );


        if (
          !gallery ||
          typeof gallery.dekofarV2ShowMedia !==
            'function'
        ) {

          return;
        }



        productRoot.dataset
          .dekofarV2GallerySyncInitialized =
          'true';



        /* =====================================================
           KULLANICI VARYANT ALANINA DOKUNDU MU?

           Sayfa ilk açıldığında FALSE.

           Core istediği kadar başlangıç
           variant-change eventi göndersin,
           galeri değişmeyecek.
        ===================================================== */

        let userInteractedWithVariant =
          false;



        /* =====================================================
           GERÇEK KULLANICI ETKİLEŞİMİNİ YAKALA

           Paint:
           - renk kartı
           - paket kartı

           Genel:
           - option select
        ===================================================== */


        productRoot.addEventListener(
          'pointerdown',
          (event) => {


            const target =
              event.target;


            if (
              !target ||
              typeof target.closest !==
                'function'
            ) {

              return;
            }



            const variantControl =
              target.closest(
                [
                  '[data-dekofar-v2-color-value]',
                  '[data-dekofar-v2-package-value]',
                  '.dekofar-v2-color-card',
                  '.dekofar-v2-package-card',
                  '.dekofar-v2-option select',
                  'select[data-option-position]'
                ].join(',')
              );


            if (
              variantControl
            ) {

              userInteractedWithVariant =
                true;
            }

          },
          true
        );



        /*
         * Klavye ile select / kart kullanımını
         * da kullanıcı etkileşimi say.
         */

        productRoot.addEventListener(
          'keydown',
          (event) => {


            const target =
              event.target;


            if (
              !target ||
              typeof target.closest !==
                'function'
            ) {

              return;
            }


            const variantControl =
              target.closest(
                [
                  '[data-dekofar-v2-color-value]',
                  '[data-dekofar-v2-package-value]',
                  '.dekofar-v2-color-card',
                  '.dekofar-v2-package-card',
                  '.dekofar-v2-option select',
                  'select[data-option-position]'
                ].join(',')
              );


            if (
              variantControl
            ) {

              userInteractedWithVariant =
                true;
            }

          },
          true
        );



        /* =====================================================
           VARYANT MEDYA ID
        ===================================================== */

        const getVariantMediaId =
          (variant) => {


            if (
              !variant
            ) {

              return null;
            }



            let mediaId =
              null;



            /* -------------------------------------------------
               CORE HELPER
            ------------------------------------------------- */

            if (
              typeof dekofarV2GetFeaturedMediaId ===
                'function'
            ) {

              try {

                mediaId =
                  dekofarV2GetFeaturedMediaId(
                    variant
                  );

              } catch (error) {

                mediaId =
                  null;
              }

            }



            /* -------------------------------------------------
               SHOPIFY FALLBACK
            ------------------------------------------------- */

            if (
              !mediaId &&
              variant.featured_media &&
              variant.featured_media.id
            ) {

              mediaId =
                variant.featured_media.id;
            }



            if (
              !mediaId &&
              variant.featured_image &&
              variant.featured_image.id
            ) {

              mediaId =
                variant.featured_image.id;
            }



            return mediaId;
          };



        /* =====================================================
           VARYANT GÖRSELİNİ GÖSTER
        ===================================================== */

        const showVariantMedia =
          (variant) => {


            if (
              !variant
            ) {

              return;
            }



            const mediaId =
              getVariantMediaId(
                variant
              );



            /*
             * Varyantın featured media'sı yoksa
             * mevcut galeri görseline dokunma.
             */

            if (
              !mediaId
            ) {

              return;
            }



            gallery.dekofarV2ShowMedia(
              mediaId,
              {

                autoplayVideo:
                  false,

                scrollThumbnail:
                  false,

                animateFromRight:
                  false,

                cancelTeaser:
                  true

              }
            );

          };



        /* =====================================================
           VARIANT CHANGE EVENT

           ÇOK ÖNEMLİ:

           userInteractedWithVariant FALSE ise:
           → sayfa açılışıdır
           → hiçbir şey yapma

           TRUE ise:
           → kullanıcı varyant değiştirmiştir
           → varyant görselini göster
        ===================================================== */

        productRoot.addEventListener(
          'dekofar:v2:variant-change',
          (event) => {


            /* -------------------------------------------------
               SAYFA İLK AÇILIŞ

               KAPAK GÖRSELİNİ KORU
            ------------------------------------------------- */

            if (
              !userInteractedWithVariant
            ) {

              return;
            }



            /* -------------------------------------------------
               VARYANT
            ------------------------------------------------- */

            const variant =
              (
                event.detail &&
                event.detail.variant
              )
                ? event.detail.variant
                : null;



            if (
              !variant
            ) {

              return;
            }



            /* -------------------------------------------------
               KULLANICI VARYANT DEĞİŞTİRDİ

               ARTIK VARYANT GÖRSELİNE GEÇ
            ------------------------------------------------- */

            showVariantMedia(
              variant
            );

          }
        );

      }
    );
}


/* =========================================================
   OPTIONAL AUTOMATIC INITIALIZATION FALLBACK

   Eğer ana sistem/core zaten bu fonksiyonları
   çağırıyorsa tekrar initialization olmaz,
   çünkü dataset guard mevcut.

   Bu bölüm sayesinde dosya tek başına
   yüklenirse de gallery initialize olabilir.
   ========================================================= */

(function dekofarV2GalleryAutoBoot() {

  const boot = () => {

    try {

      dekofarV2InitProductGalleries(
        document
      );

    } catch (error) {

      console.error(
        '[Dekofar V2] Gallery initialization error:',
        error
      );
    }


    try {

      dekofarV2InitVariantGallerySync(
        document
      );

    } catch (error) {

      console.error(
        '[Dekofar V2] Variant gallery sync error:',
        error
      );
    }
  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );

  } else {

    boot();
  }

})();
